<template>
  <Header></Header>
  <div class="content">
    
    <SideMenu></SideMenu>
    
    
  </div>
  <div>
  </div>
  <Footer></Footer>
    
    <!-- <div class="sidebar">
      <RouterLink to="/" class="{ 'active-link': $route.path === '/' }"><img src="./assets/home.png" alt="Home" id="icons"><span style="padding-left: 15px;">Home</span> </RouterLink>
      <RouterLink to="/requiredDisclosure"><img src="./assets/disclosure.png" alt="509 Disclosure" id="icons"><span style="padding-left: 15px;">509 Required Disclosure</span></RouterLink>
      <RouterLink to="/employmentOutcomes"><img src="./assets/employment.png" alt="Employment Outcomes" id="icons"><span style="padding-left: 15px;">Employment Outcomes</span></RouterLink>
      <RouterLink to="/barPassageOutcomes"><img src="./assets/barpassage.png" alt="Bar Passage Outcomes" id="icons"><span style="padding-left: 15px;">Bar Passage Outcomes</span></RouterLink>
      <a href="#terms" id="terms"><img src="./assets/terms.png" alt="Terms" id="icons"><span style="padding-left: 15px;">Terms Of Use</span></a>
    </div>
    <main>
      <RouterView />
    </main> -->
    
</template>

<script>

import Header from './components/Header'
import Footer from './components/Footer'
import SideMenu from './components/SideMenu'


export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SideMenu
  }
}
</script>

<style>
.app{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;

}
    .content {
        flex: 1;
        overflow: hidden;
    }

</style>


